import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataStorageService } from '@shared/services/data-storage.service';
//import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService, AuthenticationService } from '@shared/services';
import esJson from '../../../assets/i18n/es.json';
import enJson from '../../../assets/i18n/en.json';



@Component({
    selector: 'app-associate-form',
    templateUrl: './associate-form.component.html',
    styleUrls: ['./associate-form.component.scss'],
    standalone: false
})


export class AssociateFormComponent implements OnInit {

  langJson = (localStorage.getItem('lang') === 'es') ? esJson : enJson;
  tittle = (localStorage.getItem('lang') === 'es') ? 'Asociar pulsera a email' : 'Associate wristband to email';
  asociar = (localStorage.getItem('lang') === 'es') ? 'Asociar' : 'Associate';
  minDate: Date;
  maxDate: Date;
  uploadForm: any;
  imgURL: any;
  selectedColor: any;
  myForm: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<AssociateFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data_form: any,
    public dataStorageService: DataStorageService,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    ) {
      const currentYear = new Date().getFullYear();
      const currentDate = new Date().toString();
      this.minDate = new Date(currentDate);
      this.maxDate = new Date(currentYear + 20, 11, 31);
      this.myForm = formBuilder.group({
        email: ['', [Validators.pattern('^[a-zA-Z0-9.!#$%&’*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$'),
          Validators.required]]
      });

    }

  ngOnInit(): void {
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
  }

  onSubmit() {
    this.authenticationService.setLoader(true);
    const wristbandId = this.data_form;

    this.dataStorageService
      .associateWristbandToEmail(wristbandId, this.myForm.value['email'])
      .subscribe({
        next: (data) => {
          this.authenticationService.setLoader(false);

          this.dialogRef.close({
            success: true,
            type: 'associateSuccess',
            result: data
          });
        },
        error: (err) => {
          console.error(err?.error);
          this.authenticationService.setLoader(false);

          this.dialogRef.close({
            success: false,
            error: true,
            type: 'associateError',
            errorMessage:
              err?.error ||
              ((localStorage.getItem('lang') === 'es')
                ? 'Ha ocurrido un error al asociar la pulsera.'
                : 'An error occurred while associating the wristband.')
          });
        }
      });
  }


  onClose(){
    this.dialogRef.close();
  }


}
